import type { Resource } from '../../';
export const header_navigation_back: Resource = {"default":""};
